import React, {useEffect, useState, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {RootState} from 'modules';
import {
  // setTimelineAction,
  setNextSectionAction,
  addSectionAction,
  setPrevSectionAction,
} from 'modules/timeline';
import {
  getProgressBarPostitionByTime,
  convertSecondToTime,
  // roundTime,
  // convertTimeToSecond,
  getProgressPixelByPosition,
  // getPixelByTime,
  getNearValue,
} from 'lib/utils';
import EditTimeline from 'components/edit/EditTimeline';
import {isEditangleAction} from 'modules/ui';
import {t} from 'lib/i18n';

const TIMELINE_ARRAY = [
  1, 2, 3, 5, 6, 10, 15, 30, 60, 120, 180, 300, 360, 900, 1800, 3600, 7200,
  10800,
]; // 타임라인 표시 배열

const TIMELINE_COUNT = 4; // 한 화면에 보여지는 타임라인 헤드라인 갯수
// const TIMELINE_MAX_PERCENT = 85; // 타임라인 표시할 최대 left % 값
// const TIMELINE_BACKDROP_HEIGHT = 6;
// const TIMELINE_INDICATOR_WIDTH = 1; // 타임라인 막대 너비
// const TIMELINE_INDICATOR_HEIGHT = 3; // 타임라인 막대 높이
// let TIMELINE_RESOLUTION = 2; // 타임라인 막대 간의 간격(seconds)

let RANGE = 0;

// 시간 당 타임라인 배열
const TIMELINE_HOUR_ARR = [
  {
    startTime: 0,
    endTime: 0,
  },
];

let editangleAlert = false;

/**
 * 편집 영역 타임라인 컨테이너
 */
const EditTimelineContainer = () => {
  const dispatch = useDispatch();
  const {
    totalDuration,
    // zoom: ZOOM,
    sectionLists,
    sectionIdx,
    file,
    editangle,
    isEditangle,
  } = useSelector((state: RootState) => ({
    totalDuration: state.video.totalDuration,
    playingTime: state.video.playingTime,
    // zoom: state.timeline.zoom,
    sectionLists: state.timeline.sectionLists,
    sectionIdx: state.timeline.sectionIdx,
    file: state.file,
    editangle: state.getEditangle.data,
    isEditangle: state.ui.isEditangle,
  }));
  const [rightEndTime] = useState(10);
  const [prevSectionBtn, setPrevSectionBtn] = useState(false);
  const [NextSectionBtn, setNextSectionBtn] = useState(false);

  const timelineRef = useRef<HTMLCanvasElement>(null);
  const lastLineRef = useRef<HTMLDivElement>(null);

  // let reduxTimeline = initialState; // 리덕스 timeline 초기값 가져옴

  // 캔버스 스타일
  const canvasStyle = {
    fontSizeOrFamily: '15px NG',
    fontColor: '#ccc',
    lineColor: '#525558',
    redColor: '#cf1414',
    editColor: '#00c0ff',
  };

  // const initTimeline = () => {
  //     let timeLineList = []; // 타임라인 리스트
  //     const interval = TIMELINE_COUNT * RANGE; // 타임라인별 간격
  //     let lowerLimit = PLAYING_TIME - interval / 2;
  //     if (lowerLimit <= 0) {
  //         lowerLimit = 0;
  //     }

  //     for (let i = 1; i <= TIMELINE_COUNT; i++) {
  //         const time = lowerLimit + i * RANGE; // seconds
  //         timeLineList.push(time);
  //     }

  //     return timeLineList;
  // };

  // useEffect(() => {
  //     if (!timelineRef.current) return;

  //     const ctx = timelineRef.current.getContext("2d");
  //     if (!ctx) return;

  //     // let id = 0;
  //     const _render = () => {
  //         let headLineList: number[] = [];
  //         if (!timelineRef.current) return;

  //         ctx.clearRect(
  //             0,
  //             0,
  //             timelineRef.current.offsetWidth,
  //             timelineRef.current.height,
  //         );
  //         initTimeline(headLineList, playingTime);
  //         drawTimeline(ctx, headLineList, playingTime);

  //         // 재생시간이 70% 넘었으면 rightEndTime 비례해서 증가
  //         const standardTime = rightEndTime * 0.7;
  //         if (playingTime > standardTime) {
  //             // ex. rightEndTIme = 10, standardTime = 7초, playingTime = 8초,
  //             // = 10/7 * 8 = 11.42
  //             const endTime = (rightEndTime / standardTime) * playingTime;
  //             setRightEndTime(endTime);
  //         }
  //         // id = requestAnimationFrame(_render);
  //     };
  //     _render();

  //     // return () => {
  //     //     console.log("====================== CANCEL ANIMATION");

  //     //     cancelAnimationFrame(id);
  //     // };
  // }, [playingTime]);

  useEffect(() => {
    if (totalDuration <= 0) return;

    if (sectionLists.length <= 1) {
      initTimelineArr();
    }
    drawTimeline();
    // drawAdultLine();
    drawPrevNextBtn();

    // timeline render
  }, [totalDuration, sectionIdx, editangle, isEditangle]);

  /**
   * Pixel 계산 함수
   * @param time seconds
   */
  const getPixel = (time: number) => {
    if (!timelineRef.current) return 0;

    // 총 시간에 비례한 현재 재생 시간 % 값 얻어옴
    // const percent = getProgressBarPostitionByTime(time, duration);
    // // 현재 재생시간 %를 pixel로 변환
    // const px = getProgressPixelByPosition(wrapRef.current, percent);

    const sectionTime = time - TIMELINE_HOUR_ARR[sectionIdx].startTime; // 현재 섹션의 시간 값
    const sectionDuration =
      TIMELINE_HOUR_ARR[sectionIdx].endTime -
      TIMELINE_HOUR_ARR[sectionIdx].startTime; // 현재 섹션의 duration

    const percent = getProgressBarPostitionByTime(sectionTime, sectionDuration);

    const px = getProgressPixelByPosition(timelineRef.current, percent);

    return px;
  };

  /**
   * 타임라인 배열 초기화
   */
  const initTimelineArr = () => {
    const divideSeconds = 3600;
    const cnt = totalDuration / divideSeconds;
    let startTime = 0;
    let endTime = 0;
    let idx = 0;

    for (let i = 1; i <= cnt; i++) {
      endTime = i * divideSeconds;
      startTime = endTime - divideSeconds;
      TIMELINE_HOUR_ARR[idx++] = {
        startTime,
        endTime,
      };
    }
    const remainder = totalDuration % divideSeconds;

    if (totalDuration > totalDuration - remainder) {
      TIMELINE_HOUR_ARR[idx] = {
        startTime: totalDuration - remainder,
        endTime: totalDuration,
      };
    }

    dispatch(addSectionAction(TIMELINE_HOUR_ARR));
  };

  /**
   * 타임라인 캔버스 그리는 함수
   */
  const drawTimeline = () => {
    if (!timelineRef.current) return;
    if (!TIMELINE_HOUR_ARR[sectionIdx]) return;

    const canvasWidth = timelineRef.current.width;
    const canvasHeight = timelineRef.current.height;
    const ctx = timelineRef.current.getContext('2d');
    if (!ctx) return;

    ctx.clearRect(0, 0, canvasWidth, canvasHeight);

    ctx.font = canvasStyle.fontSizeOrFamily;
    ctx.fillStyle = canvasStyle.fontColor;

    const timeLineStartTime = TIMELINE_HOUR_ARR[sectionIdx].startTime;
    const timeLineEndTime = TIMELINE_HOUR_ARR[sectionIdx].endTime;
    const sectionDuration = timeLineEndTime - timeLineStartTime;
    const calcRoundTime = sectionDuration / TIMELINE_COUNT;
    const near = getNearValue(TIMELINE_ARRAY, calcRoundTime);
    const abs = Math.abs(sectionDuration - near * 4);
    const idx = TIMELINE_ARRAY.indexOf(near);

    if (abs <= near * 1.7 || idx === TIMELINE_ARRAY.length) {
      RANGE = near;
    } else {
      RANGE = TIMELINE_ARRAY[idx + 1];
    }

    let plusRoundTime = timeLineStartTime;
    let interval = 0;
    for (let i = 0; i <= TIMELINE_COUNT; i++) {
      const time = convertSecondToTime(plusRoundTime);
      const percent = getProgressBarPostitionByTime(interval, sectionDuration);
      const px = Math.round(canvasWidth * (percent / 100));

      // endLine 근처에 가면 겹쳐 보이는 효과 있어서 px 여분으로 주고 그것보다 클 경우(겹칠 경우) continue
      if (canvasWidth - 100 < px) {
        plusRoundTime += RANGE;
        interval += RANGE;
        continue;
      }
      ctx.fillText(time, px + 8, 15);

      ctx.beginPath();
      // if (i >= TIMELINE_COUNT) {
      //     ctx.closePath(); // 마지막은 라인 닫기
      // } else {
      ctx.moveTo(px, 5); // 라인 시작 x,y
      ctx.lineTo(px, 50); // 라인 끝 x,y
      // }
      // ctx.moveTo(canvasWidth, 5); // default 끝 라인 그리기
      // ctx.lineTo(canvasWidth, 50); // default 끝 라인 그리기

      ctx.strokeStyle = canvasStyle.lineColor;
      ctx.stroke(); // 라인 그리기
      ctx.closePath(); // 라인 닫기

      plusRoundTime += RANGE;
      interval += RANGE;
    }
    // default 끝 라인 그리기
    const endTime = convertSecondToTime(timeLineEndTime);
    ctx.fillText(endTime, canvasWidth - 60, 15);
    ctx.beginPath();
    ctx.moveTo(canvasWidth, 5);
    ctx.lineTo(canvasWidth, 50);
    ctx.strokeStyle = canvasStyle.lineColor;
    ctx.stroke(); // 라인 그리기
    ctx.closePath(); // 라인 닫기

    drawAdultLine(ctx); // 19세 영역 그림
    if (isEditangle) {
      // 편집각 노출 체크 되어 있을 경우에만 그림
      drawEditangleLine(ctx); // 편집각 그림
    }
  };

  /**
   * 19세 시청불가 영역 라인
   */
  const drawAdultLine = (ctx: CanvasRenderingContext2D) => {
    if (!timelineRef.current) return;

    let sTime = 0,
      eTime = 0;
    const adultArr: Array<{sTime: number; eTime: number}> = [];

    for (const fInfo of file.list) {
      const {grade, duration} = fInfo;
      eTime += duration;
      if (grade === 19) {
        adultArr.push({
          sTime,
          eTime,
        });
      }
      sTime = eTime;
    }

    // 19세 영역 없으면 리턴
    if (adultArr.length <= 0) return;

    const {startTime, endTime} = TIMELINE_HOUR_ARR[sectionIdx]; // 구간별 startTime, endTime
    for (const adultInfo of adultArr) {
      const {sTime: adultStime, eTime: adultEtime} = adultInfo; // 19세 영역 startTime, endTime
      let sPx = 0,
        ePx = 0,
        width = 0;

      if (adultStime >= startTime) {
        sPx = getPixel(adultStime);
      }

      if (adultEtime <= endTime) {
        ePx = getPixel(adultEtime);
      } else {
        ePx = timelineRef.current.width;
      }
      width = ePx - sPx;

      if (width <= 0) continue;

      ctx.fillStyle = canvasStyle.redColor;
      ctx.fillRect(sPx, 47, width, 3);
    }
  };

  /**
   * 편집각 그리는 함수
   */
  const drawEditangleLine = (ctx: CanvasRenderingContext2D) => {
    const checkbox = document.getElementById('check1') as HTMLInputElement;

    if (editangle.error && !editangleAlert) {
      alert(t('편집각을 표시할 수 없습니다.'));
      editangleAlert = true; // 한번 표시한 얼럿은 두번 안띄움
      checkbox.checked = false;
      dispatch(isEditangleAction(false));
      return;
    }
    if (!editangle.data) return;
    if (!editangle.data.EDITANGLE_CNT) {
      alert(t('편집각 데이터가 없습니다.'));
      checkbox.checked = false;
      dispatch(isEditangleAction(false));
      return;
    }
    if (!editangle.data.EDITANGLE_LIST) return;

    const editangleArr: Array<{fileInfoKey: string; editTime: number}> = [];
    for (const eData of editangle.data.EDITANGLE_LIST) {
      let totalDuration = 0;
      for (const fInfo of file.list) {
        if (!fInfo.file_info_key) return;

        if (eData.file_info_key === fInfo.file_info_key) {
          // VOD 플레이어 내 VideoControlbar.js > setEditangleList() 함수 로직 가져옴
          // eData는 API 단에서 type지정 안되어 있기 때문에 숫자는 Number로 변경해서 계산
          const lastSec = fInfo.duration - Number(eData.edit_time);
          const lastSecCheck = 60 < lastSec ? 0 : 60 - lastSec;
          let editTime = eData.edit_time - (lastSecCheck + 120);

          if (editTime > 0) {
            editTime = editTime + totalDuration;
          } else {
            editTime = totalDuration;
          }

          editangleArr.push({
            fileInfoKey: eData.file_info_key,
            editTime,
          });
          continue;
        }
        totalDuration += fInfo.duration;
      }
    }
    // 편집각 데이터 없으면 리턴
    if (editangleArr.length <= 0) return;

    const {startTime, endTime} = TIMELINE_HOUR_ARR[sectionIdx]; // 구간별 startTime, endTime
    for (const {editTime} of editangleArr) {
      if (editTime >= startTime && editTime <= endTime) {
        const editX = getPixel(editTime);

        ctx.lineWidth = 0.5;
        ctx.beginPath();
        ctx.moveTo(editX - 4, 36);
        ctx.lineTo(editX, 40);
        ctx.lineTo(editX + 4, 36);
        ctx.moveTo(editX - 4, 40);
        ctx.lineTo(editX, 44);
        ctx.lineTo(editX + 4, 40);
        ctx.strokeStyle = canvasStyle.editColor;
        ctx.stroke();
        ctx.closePath();
      }
    }
  };

  /**
   * 이전, 다음 섹션 버튼 display
   */
  const drawPrevNextBtn = () => {
    if (sectionIdx !== 0) {
      setPrevSectionBtn(true);
    } else {
      setPrevSectionBtn(false);
    }

    if (sectionIdx + 1 !== TIMELINE_HOUR_ARR.length) {
      setNextSectionBtn(true);
    } else {
      setNextSectionBtn(false);
    }
  };

  /**
   * 이전 섹션 클릭 함수
   */
  const onClickPrevSection = () => {
    dispatch(setPrevSectionAction(sectionIdx - 1));
  };

  /**
   * 다음 섹션 클릭 함수
   */
  const onClickNextSection = () => {
    dispatch(setNextSectionAction(sectionIdx + 1));
  };

  return (
    <EditTimeline
      totalDuration={totalDuration}
      rightEndTime={rightEndTime}
      timelineRef={timelineRef}
      lastLineRef={lastLineRef}
      prevSectionBtn={prevSectionBtn}
      NextSectionBtn={NextSectionBtn}
      onClickPrevSection={onClickPrevSection}
      onClickNextSection={onClickNextSection}
    />
  );
};

export default EditTimelineContainer;
